<div class="login-container">
  <div class="header">
    <Header />
  </div>
  <div class="content">
    <Content />
  </div>
  <div class="footer">
    <Footer />
  </div>
</div>